<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="servicesFiltered"
        :fields="fields"
        name="reporte_detalle.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
        <v-card-title>
          <v-select
            :items="services"
            v-model="service_filter"
            label="Servicio"
          ></v-select>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
          <v-data-table
            :headers="headers"
            :items="servicesFiltered"
            class="elevation-1"
            :search="search"
            item-key="id" 
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.service_name }}</td>
              <td class="text-xs-center">{{ props.item.username }}</td>
              <td class="text-xs-center no-wrap">{{ props.item.name }}</td>
              <td class="text-xs-center">{{ props.item.student_id }}</td>
              <td class="text-xs-center">{{ props.item.student }}</td>
              <td class="text-xs-center">{{ props.item.price }}</td>
              <td class="text-xs-center">{{ props.item.payment_state }}</td>
              <td class="text-xs-center no-wrap">{{ props.item.payment_date ? props.item.payment_date.substr(0,10) : '' }}</td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  export default {
    name: 'school-services-report-view',
    components: {
      'download-excel': JsonExcel,
    },
    data() {
      return {
        headers: [
          { text: 'Servicio', value: 'service_name', align: 'center' },
          { text: 'Usuario', value: 'username', align: 'center' },
          { text: 'Usuario', value: 'name', align: 'center' },
          { text: 'Estudiante', value: 'student_id', align: 'center' },
          { text: 'Estudiante', value: 'student', align: 'center' },
          { text: 'Valor', value: 'price', align: 'center' },
          { text: 'Estado Pago', value: 'payment_state', align: 'center' },
          { text: 'Fecha Pago', value: 'payment_date', align: 'center' },
        ],
        items: [],
        search: '',
        fields: {
          'service_name': 'service_name',
          'username': 'username',
          'name': 'name',
          'student_id': 'student_id',
          'student': 'student',
          'price': 'price',
          'payment_state': 'payment_state',
          'payment_date': 'payment_date',
        },
        services: [],
        service_filter: ''
      }
    },
    computed: {
      servicesFiltered() {
        return this.items
          .filter(service => service.id === this.service_filter)
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/school/services/report/byuser')
          .then(resp => {
            if (resp.status === 200) {
              this.items = resp.data.services
              this.services = resp.data.all_services.map(service => {
                return {
                  value: service.id,
                  text: service.name,
                }
              })
            }
          })
          .catch(error => console.log(error))
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/school/services/report.vue